// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3HiDT","alertIcon":"ConfirmModal_alertIcon__2VEl3"};